import React, { useEffect, useState } from "react";
import {
  Table,
  Empty,
  Col,
  Row,
} from "antd";
import {
  BarsOutlined,
  MenuUnfoldOutlined
} from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";

import { odata } from "../Filters/Helper";
import {Link} from "react-router-dom";
import CreditReportTableFilter from "../Filters/CreditReportTableFilter";
import moment from "moment";
import { useLocation, useHistory } from 'react-router-dom';

function CreditReport() {

  const location = useLocation();
  const history = useHistory();

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [startDate, setStartDate] = useState(moment().add(-1,"month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: `date(filterStartDate) ge ${startDate} and date(filterEndDate) lt ${endDate}`,
    values: {
      filterStartDate: startDate,
      filterEndDate: endDate,
    }
  });

  const [order, setOrder] = useState("");


  useEffect(() => {
    if(location.state) {
      setStartDate(location.state.startDate);
      setEndDate(location.state.endDate);

      setTableDataQueryOptions({
        ...tableDataQueryOptions,
        skip: 0,
        current: 1,
        filter: `date(filterStartDate) ge ${location.state.startDate} and date(filterEndDate) lt ${location.state.endDate}`,
        values: {
          filterStartDate: location.state.startDate,
          filterEndDate: location.state.endDate,
        },
      });

      history.replace({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
        state: null
      });
    }

  },[])
  useEffect(() => {
    if(location.state) {
      if(location.state.startDate === startDate && location.state.endDate === endDate) {
        getTableData();
      }
    }
    else {
      getTableData()
    }

  }, [order, tableDataQueryOptions]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = '';
    const { skip, take, filter } = tableDataQueryOptions;

    const conditions = [];

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }

    RequestHandler.get(
      `/CreditList?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: `date(filterStartDate) ge ${moment().add(-1,"month").format("YYYY-MM-DD")} and date(filterEndDate) lt ${moment().format("YYYY-MM-DD")}`,
      values: {
        filterStartDate: moment().add(-1,"month").format("YYYY-MM-DD"),
        filterEndDate: moment().format("YYYY-MM-DD"),
      }
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, _, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(orderBy);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };


  const columns = [
    {
      title: "Banka",
      dataIndex: "bank",
      render: (text) => {
        return (
          <div style={{ width: 100 }}>
            {" "}
            <img src={text}></img>
          </div>
        );
      },
    },
    {
      title: "Hesap Adı",
      dataIndex: "accountName"
    },
    {
      title: "Hesap No/Iban",
      dataIndex: "accountNumber",
    },
    {
      title: "Para Birimi",
      dataIndex: "currency"
    },
    {
      title: "KMH Kullanım Sayısı",
      dataIndex: "dayCount"
    },
    {
      title: "Detay",
      dataIndex: "id",
      align: "right",
      width: "10%",
      render: (data) => (
        <Link to={`/credit-report-detail/${data}&${startDate}&${endDate}`} style={{ textDecoration: 'none' }} >
          <MenuUnfoldOutlined style={{ fontSize: "130%" }} />
        </Link>
      ),
    }
  ];

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={14}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> KMH RAPORU
          </p>
        </Col>
      </Row>


      <CreditReportTableFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        setStartDate = {setStartDate}
        setEndDate = {setEndDate}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%" }}
            rowKey="id"
            filterable={true}
            size="small"
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
          />
        </Col>
      </Row>
    </>
  );

}

export default CreditReport;
